module.exports = __webpack_public_path__ + "617be8959af8875217baa2db9a4ffabb.png";